import wsgsig from '@didi/wsgsig'
import { isPassenger } from './env'
import store from '../../store'
import { get, locate, build, request } from '@didi/webx-js'

function requestCityid(params) {
  const api = 'https://common.diditaxi.com.cn/webcore/geo/reversegeotop'
  return get(api, { params })
    .then(res => {
      if (res.errno === 0 && res.data) {
        return Promise.resolve({
          errno: 0,
          errmsg: 'ok',
          cityId: res.data.cityid,
          lat: params.from_lat,
          lng: params.from_lng,
        })
      }
      return Promise.resolve({ errno: -1, errmsg: res.errmsg, cityId: null })
    })
    .catch(err => {
      return Promise.resolve({ errno: -1, errmsg: err, cityId: null })
    })
}

export function getCityInfo(queryLocateInfo = {}) {
  /* eslint-disable-next-line */
  return new Promise(async resolve => {
    const { lat, lng, cityId } = queryLocateInfo
    // 如果已经有 cityId，则直接返回，不发起经纬度请求
    if (cityId) {
      resolve({
        errno: 0,
        errmsg: 'ok',
        cityId,
        lat: lat || 0,
        lng: lng || 0,
      })
      return
    }
    // 只有在没有 cityId 且有经纬度的情况下才调用 requestCityid
    if (lat && lng) {
      const params = {
        from_lat: lat || -1,
        from_lng: lng || -1,
      }
      const res = await requestCityid(params)
      if (res.errno === 0) {
        resolve(res)
        return
      }
    }
    locate()
      .then(res => {
        const { lat, lng, cityId } = res
        if (+cityId && +cityId !== -1) {
          return resolve({
            errno: 0,
            errmsg: 'ok',
            cityId: cityId,
            lat,
            lng,
          })
        }
        return resolve({ errno: -1, errmsg: res.errmsg, cityId: null })
      })
      .catch(err => {
        return resolve({ errno: -1, errmsg: err, cityId: null })
      })
  })
}

function getUrl(method, url, noCache, data, headers = {}) {
  const ts = 'ts'
  const timestamp = new Date().getTime()
  if (noCache) {
    url = `${url}?${ts}=${timestamp}`
  }
  for (const key in data) {
    if (data[key] === undefined || data[key] === null) {
      data[key] = ''
    }
  }
  // 计算wsgsig签名
  let signParams = null
  let signBody = null
  let contentType = 'application/json'
  if (method === 'GET' || method.toUpperCase() === 'get') {
    signParams = data
  } else if (method === 'POST' || method.toUpperCase() === 'post') {
    signBody = data
    contentType =
      headers['content-type'] ||
      headers.contentType ||
      'application/x-www-form-urlencoded'
  }
  if (noCache) {
    signParams = {
      ...signParams,
      [ts]: timestamp,
    }
  }
  if (contentType === 'application/x-www-form-urlencoded') {
    signBody = build('', signBody)
    signBody = signBody.slice(1)
  } else if (
    (method === 'POST' || method.toUpperCase() === 'post') &&
    contentType === 'application/json'
  ) {
    signBody = JSON.stringify(signBody)
  }
  const params = {
    params: signParams,
    bodyString: signBody,
    bodySerializer: JSON.stringify,
    noDomainCheck: true,
    contentType: contentType,
  }
  // if (contentType === 'application/json') {
  //   params.bodySerializer = JSON.stringify
  // }
  const sign = wsgsig(params)
  if (sign && noCache) {
    url = `${url}?wsgsig=${encodeURIComponent(sign)}&ts=${timestamp}`
  } else if (sign) {
    url = `${url}?wsgsig=${encodeURIComponent(sign)}`
  }
  return url
}

const http = {
  commonRequest(
    method,
    url,
    data = {},
    { noCache, cancelToken, headers, handle } = {}
  ) {
    isPassenger() && (data.app_version = store.getters.appVersion)
    data.lang = store.getters.lang
    return new Promise((resolve, reject) => {
      request(method, getUrl(method, url, noCache, data, headers), {
        emulateJSON: true,
        data: data,
        params: method === 'get' ? data : {},
        header: {
          'content-type': 'application/x-www-form-urlencoded',
          ...headers,
        },
        cancelToken,
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  get(url, data = {}, { noCache, cancelToken, headers } = {}) {
    return http.commonRequest('GET', url, data, {
      noCache,
      cancelToken,
      headers,
    })
  },
  post(url, data = {}, { noCache, cancelToken, headers } = {}) {
    return http.commonRequest('POST', url, data, {
      noCache,
      cancelToken,
      headers,
    })
  },
}

// eslint-disable-next-line import/no-default-export
export default http
